import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux'

/** Ödül Öneri yönetici paneli — login zorunlu; yetki paneli içinde doğrulanır */
const OdulOneriManagerRoute = () => {
  const { currentUser } = useSelector((state) => state.auth)

  if (!currentUser) {
    return <Navigate to="/login" />
  }

  return <Outlet />
}

export default OdulOneriManagerRoute
